export default __webpack_public_path__ + "static/media/information--end-of-tunnel--g2.7ac93cff.png";